import React from "react";
import { NavLink, useHistory } from "react-router-dom";

import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo2 from "assets/images/favicon.png";
import styles from "./sidebar.module.css";
import useAuthStore from "store/auth";
import useUserStore from "store/user";
import { useQueryClient } from "@tanstack/react-query";
import useCookie from "hooks/useCookie";

var ps;

function Sidebar(props) {
  const icons = props.icons;
  const role = props.role;
  const sidebar = React.useRef();
  let history = useHistory();
  const { clearAuth } = useAuthStore();
  const { clearUser } = useUserStore();
  const queryClient = useQueryClient();
  const [, setJwt] = useCookie("principally");

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const handleLogout = () => {
    queryClient.clear();
    clearAuth();
    clearUser();
    setJwt("logged_out");
    history.push("/");
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo">
        <div className="logo-img ">
          <img
            src={logo2}
            alt="react-logo"
            style={{
              height: 60,
              width: 60,
            }}
          />
        </div>
      </div>
      <div
        className="sidebar-wrapper d-flex flex-column justify-content-between"
        ref={sidebar}
      >
        <Nav>
          {props.routes.map((prop, key) => (
            <li
              className={
                activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
              }
              key={key}
            >
              <NavLink
                to={prop.layout + prop.path}
                className="nav-link d-flex"
                activeClassName="active"
                style={{ color: "#000" }}
              >
                {icons[key]}
                <p className="pl-2">
                  {(role === "admin" ||
                    role === "secretary" ||
                    role === "assistprincipal") &&
                  prop.title === "Scripts"
                    ? "Principal Scripts"
                    : prop.title}
                </p>
              </NavLink>
            </li>
          ))}
        </Nav>
        <div style={{ width: "100%" }}>
          <button
            className={styles.nav_btn}
            type="button"
            onClick={handleLogout}
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
